import { atom } from 'jotai';
import { MeasurementLinesProps } from '@abyss/3d-viewer';
import { MeasurementToolState } from '@/types';

export const measurementsToAdd = atom<MeasurementLinesProps | undefined>(undefined);

export const measurementToolState = atom<MeasurementToolState>(MeasurementToolState.IN_ACTIVE);

export const measurementLineDistance = atom<number>(0);

export const activeMeasurementFieldId = atom<string | undefined>(undefined);

export const measurementsByField = atom<Record<string, MeasurementLinesProps> | undefined>(
  undefined
);
